module.exports = __webpack_public_path__ + "media/process/Process-WhatsInThisBox-17f79b5f.jpg";